import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Button,
  Checkbox,
  RouterLink,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const SaveDetalization = ({
  showSavingOptions = false,
  isEmailConfirmed,
  includeStructure = true,
  includeDetalization = true,
  sendToEmail,
  saveReport,
  toggleIncludeStructure,
  toggleIncludeDetalization,
  toggleSendToEmail,
  isSSO,
}) => (
  <form
    onSubmit={(e) => {
      e.preventDefault();
      saveReport();
    }}
  >
    <I18n path="detalization.postpaidInvoices.format" />
    <div className={cx('fileFormat')}>
      XLS
    </div>
    <div className={cx('checkboxesWrapper')}>
      <div className={cx('checkboxes')}>
        {showSavingOptions && (
          <>
            <Checkbox
              name="save-structure"
              checked={includeStructure}
              handleChange={toggleIncludeStructure}
            >
              <I18n path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.includeStructure" />
            </Checkbox>
            <Checkbox
              name="save-detalization"
              checked={includeDetalization}
              handleChange={toggleIncludeDetalization}
            >
              <I18n path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.includeDetalization" />
            </Checkbox>
          </>
        )}
        {!isSSO && (
          <Checkbox
            name="send-to-email"
            disabled={!isEmailConfirmed}
            checked={!isSSO && isEmailConfirmed && sendToEmail}
            handleChange={toggleSendToEmail}
          >
            <I18n path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.sendToEmail" />
          </Checkbox>
        )}
      </div>
      {!isSSO && (
        <>
          {isEmailConfirmed ? (
            <RouterLink
              className="link--hidden-visited-color"
              to="/settings/notifications"
            >
              <I18n path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.emailSettings" />
            </RouterLink>
          ) : (
            <>
              <I18n path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.emailIsNotSpecified" />
              ,&nbsp;
              <RouterLink
                className="link--hidden-visited-color"
                to="/settings/notifications"
              >
                <I18n path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.goToSettings" />
              </RouterLink>
            </>
          )}
        </>
      )}
    </div>
    <Button
      type="submit"
      className="big"
      disabled={!includeStructure && !includeDetalization}
    >
      <I18n path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.saveReport" />
    </Button>
  </form>
);

SaveDetalization.propTypes = {
  showSavingOptions: PropTypes.bool,
  includeStructure: PropTypes.bool,
  includeDetalization: PropTypes.bool,
  sendToEmail: PropTypes.bool,
  isEmailConfirmed: PropTypes.bool,
  toggleIncludeStructure: PropTypes.func,
  toggleIncludeDetalization: PropTypes.func,
  toggleSendToEmail: PropTypes.func,
  saveReport: PropTypes.func,
  isSSO: PropTypes.bool,
};

export default SaveDetalization;
